import { Injectable } from '@angular/core';
import { IResourceAction, Resource, ResourceHandler } from '@ngx-resource/core';
import { token_corregidora } from 'src/app/token-test-migracion';
import { AuthServerProvider } from './auth-jwt.service';

@Injectable()
export class AuthCorregidoraService extends Resource {

  private apiBaseUrl: string = 'http://187.216.144.10:9938' + '/api';
  // private apiBaseUrl: string = ''; 

  constructor(resourceHandler: ResourceHandler, private authProv: AuthServerProvider) {
    super(resourceHandler);
  }

  $getHeaders(actionOptions?: IResourceAction): any | Promise<any> {
    let headers: any = super.$getHeaders();
    if (!actionOptions.auth) {
      // headers = this.authProv.extendHeaders(headers);
      const token = token_corregidora();
      
      headers.Authorization = 'Bearer ' + token;
      console.log(headers);
    }
    return headers;
  }

  $getUrl(methodOptions?: IResourceAction): string | Promise<string> {
    const resPath = super.$getUrl();
    return this.apiBaseUrl + resPath;
  }
}
